__turbopack_context__.v({
  "button__aNlJh": "PlasmicNotificationCenter2-module__YnHUAq__button__aNlJh",
  "button__jElQ5": "PlasmicNotificationCenter2-module__YnHUAq__button__jElQ5",
  "button__jTmLq": "PlasmicNotificationCenter2-module__YnHUAq__button__jTmLq",
  "button__o7Xdh": "PlasmicNotificationCenter2-module__YnHUAq__button__o7Xdh",
  "button__tqH0F": "PlasmicNotificationCenter2-module__YnHUAq__button__tqH0F",
  "freeBox___2234J": "PlasmicNotificationCenter2-module__YnHUAq__freeBox___2234J",
  "freeBox___22TO2": "PlasmicNotificationCenter2-module__YnHUAq__freeBox___22TO2",
  "freeBox__at0Mn": "PlasmicNotificationCenter2-module__YnHUAq__freeBox__at0Mn",
  "freeBox__l39Kn": "PlasmicNotificationCenter2-module__YnHUAq__freeBox__l39Kn",
  "freeBox__uTdj7": "PlasmicNotificationCenter2-module__YnHUAq__freeBox__uTdj7",
  "freeBox__uaR54": "PlasmicNotificationCenter2-module__YnHUAq__freeBox__uaR54",
  "freeBox__vTzEk": "PlasmicNotificationCenter2-module__YnHUAq__freeBox__vTzEk",
  "h1": "PlasmicNotificationCenter2-module__YnHUAq__h1",
  "h4": "PlasmicNotificationCenter2-module__YnHUAq__h4",
  "modal": "PlasmicNotificationCenter2-module__YnHUAq__modal",
  "optimizedSupabaseImage": "PlasmicNotificationCenter2-module__YnHUAq__optimizedSupabaseImage",
  "root": "PlasmicNotificationCenter2-module__YnHUAq__root",
  "supabaseDataProviderTable": "PlasmicNotificationCenter2-module__YnHUAq__supabaseDataProviderTable",
  "text__iAbIa": "PlasmicNotificationCenter2-module__YnHUAq__text__iAbIa",
  "text__iVuQi": "PlasmicNotificationCenter2-module__YnHUAq__text__iVuQi",
  "text__r47Ve": "PlasmicNotificationCenter2-module__YnHUAq__text__r47Ve",
  "text__rwL83": "PlasmicNotificationCenter2-module__YnHUAq__text__rwL83",
  "text__sk7F": "PlasmicNotificationCenter2-module__YnHUAq__text__sk7F",
  "text__vq1NP": "PlasmicNotificationCenter2-module__YnHUAq__text__vq1NP",
  "text__vtz2R": "PlasmicNotificationCenter2-module__YnHUAq__text__vtz2R",
});
